export default __webpack_public_path__ + "media/images/landing-21-550x420-6db36f950a234da8aef0565198353032.jpg";